// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.selectWrap {
  margin-left: 0;
  border: 2px solid red !important;
}

.test .dropdown-list .selectWrap.open {
  margin-left: -30px;
}

.dropDown {
  font-family: Omnes-ATT-W02-Medium;
}

.test .selectWrap {
  margin-left: 0;
  top: 0;
}
.test .radioContainer span {
  border: 2px solid red;
}

.margin-10 {
  margin: 10px 0;
}

.report-container form .textbox {
  position: relative;
  opacity: 1;
  height: 36px !important;
}
.report-container form .form-group {
  margin: 0px;
  /*copying radio button CSS as the default is not allowing overriding */
}
.report-container form .form-group label {
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 1.6rem;
}
.report-container form .form-group .dropDown {
  font-family: Omnes-ATT-W02-Medium;
}
.report-container form .form-group h2 {
  margin-bottom: 20px;
}
.report-container form .form-group .radioContainer {
  margin-bottom: 5px;
  position: relative;
}
.report-container form .form-group .radioContainer span {
  display: inline-block;
  margin-left: 34px;
  margin-top: 0;
  position: relative;
  top: 3px;
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 1.6rem;
}
.report-container form .form-group .radioContainer input {
  height: 10px !important;
  left: 1px;
  margin: 6px;
  opacity: 0;
  outline: none;
  position: absolute;
  top: 1px;
  width: 10px;
}
.report-container form .form-group .radioContainer input:checked:not(:disabled) + .skin {
  background-color: hsl(204.9, 94.4%, 35.1%);
  border-color: #d2d2d2;
}
.report-container form .form-group .radioContainer input:checked:not(:disabled) + .skin:after {
  background-color: transparent;
  color: white;
  font-size: 23.4px;
  height: 24px;
  line-height: 21px;
  width: 24px;
}
.report-container form .form-group .radioContainer input + .skin {
  border-radius: 100%;
}
.report-container form .form-group .radioContainer input:checked + .skin:after {
  background-color: hsl(204.9, 94.4%, 35.1%);
  border: 3px solid white;
  border-radius: 100%;
  content: "";
  display: block;
  height: 16px !important;
  position: absolute;
  width: 16px !important;
}
.report-container form .form-group .radioContainer .skin {
  background-color: white;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
  display: inline-block;
  height: 24px;
  left: 0;
  position: absolute;
  top: 0;
  width: 24px;
}
.report-container form .form-group .radioContainer {
  margin-bottom: 20px;
}
.report-container form .form-group .radioContainer:last-child {
  margin-bottom: 0;
}
.report-container form .form-group .radioContainer .label-container {
  margin: 12px 32px;
}
.report-container form .form-group .radioContainer .divider {
  margin: 0;
  padding: 5px;
  position: static;
}
.report-container form .form-group .radioContainer .singleFan, .report-container form .form-group .radioContainer .singleDevice {
  margin: 20px 33px 0;
  width: 60%;
}
.report-container form .form-group .radioContainer .textbox {
  position: relative;
  opacity: 1;
  height: 36px !important;
  display: block;
  width: 100%;
}
.report-container form .form-group .radioContainer a {
  padding-left: 0;
}
.report-container form .form-group .error-text {
  color: hsl(0, 66%, 49%);
  margin: 5px 0;
}
.report-container form .form-group .error-text i {
  color: hsl(0, 66%, 49%);
}
.report-container form .form-group .error {
  color: hsl(0, 66%, 49%);
}
.report-container form .form-group .error input {
  border-color: hsl(0, 66%, 49%);
  color: hsl(0, 66%, 49%);
}
.report-container form .form-group .fan-search-bar {
  margin: 20px 0 0 33px;
  width: 65%;
}
.report-container .cta {
  border-top: 1px solid #d2d2d2;
  padding: 30px 0 60px;
  margin-top: 30px;
}

@media (max-width: 1024px) {
  .singleFan {
    margin: 20px 33px 0;
    width: 60%;
  }
  .report-container form .textbox {
    position: relative;
    opacity: 1;
    height: 36px !important;
    display: block;
    width: 100%;
  }
  .report-container form div:nth-last-of-type(2) {
    margin-bottom: 20px;
  }
  .report-container form .cta {
    padding: 20px 0 30px;
    margin: 0 1px;
  }
  .report-container form .cta a {
    text-align: center;
  }
  .report-container form .cta button {
    margin: 0 0 0 20px;
    text-align: center;
  }
  .report-container form .form-group .fan-search-bar {
    width: 90%;
  }
  .report-container form .search-fan input {
    width: 140%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/report/transaction/report-type/report-type.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,cAAA;EACA,gCAAA;AAmJJ;;AAhJA;EACI,kBAAA;AAmJJ;;AAhJA;EACI,iCAAA;AAmJJ;;AA/II;EACI,cAAA;EACA,MAAA;AAkJR;AA/II;EACI,qBAAA;AAiJR;;AA7IA;EACI,cAAA;AAgJJ;;AA3IQ;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;AA8IZ;AA3IQ;EACI,WAAA;EAeA,sEAAA;AA+HZ;AA5IW;EACC,mCAAA;EACA,iBAAA;AA8IZ;AA3IW;EACK,iCAAA;AA6IhB;AA1IY;EACI,mBAAA;AA4IhB;AAvIY;EACI,kBAAA;EAEA,kBAAA;AAwIhB;AAtIgB;EACI,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,mCAAA;EACA,iBAAA;AAwIpB;AArIgB;EACI,uBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAuIpB;AArIoB;EACI,0CAAA;EAEA,qBAAA;AAsIxB;AApIwB;EACI,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AAsI5B;AAjIgB;EACI,mBAAA;AAmIpB;AAhIgB;EACI,0CAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AAkIpB;AA/HgB;EACI,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAiIpB;AA7HY;EACI,mBAAA;AA+HhB;AA7HgB;EACI,gBAAA;AA+HpB;AA5HgB;EACI,iBAAA;AA8HpB;AA3HgB;EACI,SAAA;EACA,YAAA;EACA,gBAAA;AA6HpB;AA3HC;EACO,mBAAA;EACA,UAAA;AA6HR;AA3HI;EACY,kBAAA;EACA,UAAA;EACA,uBAAA;EACI,cAAA;EAChB,WAAA;AA6HJ;AA1HgB;EACI,eAAA;AA4HpB;AAxHY;EACI,uBAAA;EACA,aAAA;AA0HhB;AAxHgB;EACI,uBAAA;AA0HpB;AAtHY;EACI,uBAAA;AAwHhB;AAtHgB;EACI,8BAAA;EACA,uBAAA;AAwHpB;AApHY;EACI,qBAAA;EACA,UAAA;AAsHhB;AAjHI;EACI,6BAAA;EACA,oBAAA;EACA,gBAAA;AAmHR;;AFrRI;EEuKA;IACI,mBAAA;IACA,UAAA;EAkHN;EA7GU;IACI,kBAAA;IACA,UAAA;IACA,uBAAA;IACI,cAAA;IAChB,WAAA;EA+GF;EA5GU;IACI,mBAAA;EA8Gd;EA3GU;IACI,oBAAA;IACA,aAAA;EA6Gd;EA3Gc;IACI,kBAAA;EA6GlB;EA1Gc;IACI,kBAAA;IACA,kBAAA;EA4GlB;EAvGc;IACI,UAAA;EAyGlB;EApGc;IACI,WAAA;EAsGlB;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import \"../../../../../lib/ng2-sapmp/src/assets/style/mixinfunction\";\n\n.selectWrap {\n    margin-left: 0;\n    border: 2px solid red !important;\n}\n\n.test .dropdown-list .selectWrap.open {\n    margin-left: -30px;\n}\n\n.dropDown{\n    font-family: Omnes-ATT-W02-Medium;\n}\n\n.test {\n    .selectWrap {\n        margin-left: 0;\n        top: 0;\n    }\n\n    .radioContainer span {\n        border: 2px solid red;\n    }\n}\n\n.margin-10 {\n    margin: 10px 0;\n}\n\n.report-container {\n    form {\n        .textbox {\n            position: relative;\n            opacity: 1;\n            height: 36px !important;\n        }\n\n        .form-group {\n            margin: 0px;\n            \n           label{\n            font-family : 'Omnes-ATT-W02', Arial;\n            font-size: 1.6rem;\n           }\n\n           .dropDown{\n                font-family: Omnes-ATT-W02-Medium;\n            }\n\n            h2 {\n                margin-bottom: 20px;\n            }\n\n            /*copying radio button CSS as the default is not allowing overriding */\n\n            .radioContainer {\n                margin-bottom: 5px;\n                //min-height: 24px;\n                position: relative;\n\n                span {\n                    display: inline-block;\n                    margin-left: 34px;\n                    margin-top: 0;\n                    position: relative;\n                    top: 3px;\n                    font-family : 'Omnes-ATT-W02', Arial;\n                    font-size: 1.6rem;\n                }\n\n                input {\n                    height: 10px !important;\n                    left: 1px;\n                    margin: 6px;\n                    opacity: 0;\n                    outline: none;\n                    position: absolute;\n                    top: 1px;\n                    width: 10px;\n\n                    &:checked:not(:disabled) + .skin {\n                        background-color: color(secondary, base);\n                        // border-color: color(secondary, base);\n                        border-color: color( default, dark);\n\n                        &:after {\n                            background-color: transparent;\n                            color: color(default, light);\n                            font-size: 23.4px;\n                            height: 24px;\n                            line-height: 21px;\n                            width: 24px;\n                        }\n                    }\n                }\n\n                input + .skin {\n                    border-radius: 100%;\n                }\n\n                input:checked + .skin:after {\n                    background-color: color(secondary, base);\n                    border: 3px solid color(default, light);\n                    border-radius: 100%;\n                    content: '';\n                    display: block;\n                    height: 16px !important;\n                    position: absolute;\n                    width: 16px !important;\n                }\n\n                .skin {\n                    background-color: color(default, light);\n                    border: 1px solid color(default, dark);\n                    border-radius: 3px;\n                    display: inline-block;\n                    height: 24px;\n                    left: 0;\n                    position: absolute;\n                    top: 0;\n                    width: 24px;\n                }\n            }\n\n            .radioContainer {\n                margin-bottom: 20px;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n\n                .label-container {\n                    margin: 12px 32px;\n                }\n\n                .divider {\n                    margin: 0;\n                    padding: 5px;\n                    position: static;\n                }\n .singleFan,.singleDevice {\n        margin: 20px 33px 0;\n        width: 60%;\n    }\n    .textbox {\n                position: relative;\n                opacity: 1;\n                height: 36px !important;\n                    display: block;\n    width: 100%;\n            }\n\n                a {\n                    padding-left: 0;\n                }\n            }\n\n            .error-text {\n                color: color(danger, base);\n                margin: 5px 0;\n\n                i {\n                    color: color(danger, base);\n                }\n            }\n\n            .error {\n                color: color(danger, base);\n\n                input {\n                    border-color: color(danger, base);\n                    color: color(danger, base);\n                }\n            }\n\n            .fan-search-bar {\n                margin: 20px 0 0 33px;\n                width: 65%;\n            }\n        }\n    }\n\n    .cta {\n        border-top: 1px solid color(default, dark);\n        padding: 30px 0 60px;\n        margin-top: 30px;\n    }\n}\n\n@include respond-to(small) {\n    .singleFan {\n        margin: 20px 33px 0;\n        width: 60%;\n    }\n\n    .report-container {\n        form {\n            .textbox {\n                position: relative;\n                opacity: 1;\n                height: 36px !important;\n                    display: block;\n    width: 100%;\n            }\n\n            div:nth-last-of-type(2) {\n                margin-bottom: 20px;\n            }\n\n            .cta {\n                padding: 20px 0 30px;\n                margin: 0 1px;\n\n                a {\n                    text-align: center;\n                }\n\n                button {\n                    margin: 0 0 0 20px;\n                    text-align: center;\n                }\n            }\n\n            .form-group {\n                .fan-search-bar {\n                    width: 90%;\n                }\n            }\n\n            .search-fan {\n                input {\n                    width: 140%;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
